import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <Navbar/>
      <div className="max-w-lg mx-auto px-6 py-20 text-center">
        <XCircle className="mx-auto text-[#C25934]" size={40}/>
        <h1 className="font-serif-display text-3xl mt-4 text-[#1E3F33]">Pagamento annullato</h1>
        <p className="mt-3 text-[#6B6B6B]">Nessun importo è stato addebitato. Puoi riprovare in qualsiasi momento.</p>
        <Link to="/piani" data-testid="cancel-back" className="btn-lift inline-block mt-8 px-6 py-3 bg-[#1E3F33] text-white rounded-md">Torna ai piani</Link>
      </div>
    </div>
  );
}
